
import Vue from 'vue'
import { formatOneDecimal, currencySymbol } from '@/utils/common'

export default Vue.extend({
  name: 'PriceLabel',
  props: {
    customClass: {
      type: String,
      default: ''
    },
    productPrice: {
      type: [String, Number],
      required: true
    },
    minQuantity: {
      type: Number,
      required: false,
      default: 0
    },
    campaignRatio: {
      type: Number,
      required: false,
      default: 0
    },
    campaignPrice: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },
  computed: {
    currencyLabel(): string {
      return `From ${currencySymbol}`
    },
    quantityLabel(): string {
      if (!this.minQuantity || this.minQuantity == 1) return 'No Minimum Quantity'
      else return 'Order as few as '
    },
    hasCampaignPrice(): boolean {
      return this.campaignPrice !== null && (this.parseFloatValue(this.campaignPrice) < this.parseFloatValue(this.productPrice))
    }
  },
  methods: {
    formatOneDecimal,
    parseFloatValue(value: string | number): number {
      return typeof value === 'string' ? parseFloat(value) : value
    }
  }
})
